import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../../utils/common";

const E_P_P_S_T = ({ setEdit, data, currentPage, setCurrentPage }) => {
  const [showModal, setModal] = useState(false);

  const tableData = data?.data || [];
  const totalPages = data?.total_pages || 1;
  const perPage = data?.per_page || 10;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Date</th>
                <th>Vender Name</th>
                <th>Address</th>
                <th>Contact Person</th>
                <th>Email</th>
                <th>Contact No</th>
                <th>Service Used</th>
                <th>Performance</th>
                <th>Remarks</th>
              </tr>
            </thead>

            <tbody>
              {tableData.length > 0 ? (
                tableData.map((row, index) => (
                  <tr key={row.id}>
                    {/* Sr No */}
                    <td>{(currentPage - 1) * perPage + index + 1}</td>

                    {/* Document Name */}
                    <td>{formatDate(row.createdAt)}</td>
                    <td>{row.name}</td>
                    <td>{row.address}</td>
                    <td>{row.contact_person_name}</td>
                    <td>{row.email}</td>
                    <td>{row.contact_no}</td>

                    {/* Attached File */}
                    <td>{row.Service_Used?.name || "--"}</td>
                    <td>{row.Performance?.name}</td>
                    {/* Remarks */}
                    <td>{row.remark || "--"}</td>

                    {/* Action */}
                    {/* <td>
                        <div className="action_icons">
                          <p
                            className="blue_link_text"
                            onClick={() => setModal(true)}
                          >
                            Generate
                          </p>
                        </div>
                      </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          Showing page {currentPage} of {totalPages}
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default E_P_P_S_T;
